import React from 'react';
import ServicePage from '../../components/PublicSite/ServicePage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

async function action() {
  await loadSiteCopy();
  return {
    title: 'Mobile Tyre Change & Puncture Repair in the UAE | Bas Recovery',
    description: 'Flat tyre repaired or replaced where you are parked. Puncture repair from AED 65, tyres fitted from AED 230. Call 050 505 2213, 24/7.',
    component: (
      <HeadLessLayout>
        <ServicePage service="tyre" />
      </HeadLessLayout>
    ),
  };
}

export default action;
